export default __webpack_public_path__ + "static/media/pro1.879e4e69.png";